import { render } from "./wasm.vue?vue&type=template&id=6764bb2a&scoped=true&ts=true"
import script from "./wasm.vue?vue&type=script&lang=ts"
export * from "./wasm.vue?vue&type=script&lang=ts"

import "./wasm.vue?vue&type=style&index=0&id=6764bb2a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6764bb2a"]])

export default __exports__